import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Component, HostBinding, Input, ChangeDetectionStrategy, ViewEncapsulation, AfterContentInit } from '@angular/core';

import { EuiIconModule } from '../atoms';
import { BaseDirective } from '../../base.directive';

@Component({
    // template: (<any>EclButtonComponent).__annotations__[0]['template'], // TODO: check AOT build ??
    templateUrl: './eui-dashboard-button.component.html',
    selector: 'eui-dashboard-button',
    styleUrls: ['./styles/_index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiDashboardButtonComponent extends BaseDirective implements AfterContentInit {

    @Input() mainLabel: string;
    @Input() label: string;
    @Input() iconClass: string;
    @Input() subLabel: string;
    @Input() url: string;

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-dashboard-button'),
            'eui-dashboard-button--rounded',
        ].join(' ').trim();
    }

    constructor() {
        super();
    }

    ngAfterContentInit() {
    }
}

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        EuiIconModule,
    ],
    declarations: [
        EuiDashboardButtonComponent,
    ],
    exports: [
        EuiDashboardButtonComponent,
    ],
})
export class EuiDashboardButtonModule { }
